<template lang='pug' src='./app.pug'></template>

<script>
// components
import Navigation from 'components/navigation/navigation'
import NavigationClean from 'components/navigation/navigation-clean/navigation-clean'
import NavigationMobile from 'components/navigation/navigation-mobile/navigation-mobile'
import MainFooter from 'components/footer/footer'
import Modal from 'components/modal/modal'
import MainForm from 'components/form/form'
import BaseBaseAccess from 'components/base-access/index'

export default {
  data () {
    return {
      windowWidth: window.innerWidth,
      windowHeight: window.pageYOffset,
      waypoint: (window.innerHeight * 0.001)
    }
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    window.addEventListener('scroll', () => {
      this.windowHeight = window.pageYOffset
    })
  },
  created () {
    this.$store.dispatch('GET_PAGES')
    this.$store.dispatch('VIEW_NAV', false)
    this.$store.dispatch('VIEW_BODY', false)
    this.$store.dispatch('VIEW_TYPES', 0)
    this.$store.dispatch('VIEW_SHOWMODAL', false)
    this.$store.dispatch('VIEW_MODALCONTENT', false)
  },
  computed: {
    props () {
      return this.$store.state
    }
  },
  components: {
    NavigationClean,
    Navigation,
    NavigationMobile,
    MainFooter,
    Modal,
    MainForm,
    BaseBaseAccess
  },
  name: 'app'
}
</script>

<-- styles have been moved to main.sass file -->
<style src='../main.sass' lang='sass'></style>



// WEBPACK FOOTER //
// app.vue?2bf61c9a